import RedesignDescriptor from './blockedUser-module-redesign';
import RefiveDescriptor from './blockedUser-module-refive';
import ConnectDescriptor from './blockedUser-module-connect';
import AramarkDescriptor from './blockedUser-module-aramark';

import BuildTypes from 'src/constants/BuildTypeConstants';
import Settings from 'src/Settings';

const typeDescriber = {
  [BuildTypes.aramark]: AramarkDescriptor,
  [BuildTypes.canteen]: ConnectDescriptor,
  [BuildTypes.default]: RedesignDescriptor,
  [BuildTypes.companykitchen]: ConnectDescriptor,
  [BuildTypes.refive]: RefiveDescriptor,
};

export function getDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
